import React from 'react'

import { IHeaderNavigationSolutions } from '..'
import { mq } from 'marketing-site/src/library/utils'
import { HeaderNavigationSolution } from './HeaderNavigationSolution'

export const HeaderNavigationSolutions = ({
  contentType = 'flex',
  solutions,
}: IHeaderNavigationSolutions): React.ReactElement => {
  return (
    <>
      <div className="header-navigation-solutions">
        <div className="header-navigation-solutions__wrapper">
          {solutions.map((solution) => {
            return (
              <>
                <HeaderNavigationSolution {...solution} contentType={contentType} />
                <div className="solution-divider"></div>
              </>
            )
          })}
        </div>
      </div>

      <style jsx>{`
        .header-navigation-solutions {
          display: flex;
          flex-direction: column;

          &__title {
            padding: 0 0 1.5rem 0;
          }

          &__wrapper {
            display: grid;
          }
        }

        .solution-divider {
          margin: 28px 0;
          border-top: 1px solid rgb(160, 160, 160);

          &:last-child {
            border-top: unset;
            margin: 0;
          }
        }

        @media (${mq.mobile}) {
          .header-navigation-solutions {
            &__title {
              display: none;
            }
          }
        }

        @media (${mq.desktop}) {
          .header-navigation-solutions {
            &__wrapper {
              display: flex;
            }

            :global(.header-navigation-solution:not(:first-child)) {
              margin-left: 2rem;
            }
          }
        }
      `}</style>
    </>
  )
}
